/*
 * Example:
 *
 * val: 'example'
 * rules: 'email|max:30|min:40'
 *
 * */

import { EMAIL_REGEXP } from "@/config.ts";

export interface IValidateField {
  name: string;
  value: string;
  rules: string;
}

export interface IRuleObj {
  name: string;
  value: string;
}

export class validateForm {
  fieldArr: IValidateField[] = [];
  currentVal: string = "";
  isValidForm: boolean = true;

  constructor(fieldArr: IValidateField[]) {
    this.fieldArr = fieldArr;
  }

  min(val: number): boolean {
    return this.currentVal.length > val;
  }

  email(): boolean {
    return !!this.currentVal.match(EMAIL_REGEXP);
  }

  validateField(val: string, rules: IRuleObj[]) {
    this.currentVal = val;
    rules.forEach(rule => {
      let isValid: boolean;
      if (rule.value) {
        isValid = this[rule.name](rule.value);
      } else {
        isValid = this[rule.name]();
      }
      if (!isValid) {
        this.isValidForm = false;
      }
    });
  }

  splitRules(field: IValidateField): IRuleObj[] {
    return field.rules.split("|").map(_rule => {
      const rule_spl = _rule.split(":");
      return {
        name: rule_spl[0],
        value: rule_spl[1] || ""
      };
    });
  }

  checkFields(): void {
    this.fieldArr.filter((field: IValidateField) => {
      const rules: IRuleObj[] = this.splitRules(field);
      this.validateField(field.value, rules);
    });
  }

  isValid(): boolean {
    this.checkFields();
    return this.isValidForm;
  }
}
